import VideoModalButton from './VideoModalButton'

export default VideoModalButton
